export default __webpack_public_path__ + "static/media/intro-cat-blue.5626bb32.png";